import React, { FC } from 'react';

import { MapPin, User } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { MAP_ROUTE } from 'routes/map/list';
import { PROFILES_ROUTE } from 'routes/profiles/list';

import { useApiPassword } from '@/hooks/useApiPassword';
import { cn } from '@/lib/utils';
import { ApiPasswordGate } from '@/components/api-password-gate';
import Pages from 'pages';

export const AppPrepare: FC = () => {
  const { password, isRejected } = useApiPassword();

  if (!password) {
    return <ApiPasswordGate isRejected={isRejected} />;
  }

  return <App />;
};

interface NavItem {
  icon: React.ReactNode;
  label: string;
  to: string;
}

const items: NavItem[] = [
  {
    icon: <User className="size-4" />,
    label: 'Profiles',
    to: PROFILES_ROUTE,
  },
  {
    icon: <MapPin className="size-4" />,
    label: 'Map',
    to: MAP_ROUTE,
  },
];

const App: FC = () => {
  return (
    <div className="flex h-screen overflow-hidden">
      <aside className="w-56 shrink-0 overflow-y-auto bg-zinc-900 text-zinc-100">
        <nav className="flex flex-col gap-1 p-2">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-zinc-800 text-white'
                    : 'text-zinc-300 hover:bg-zinc-800 hover:text-white',
                )
              }>
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="flex-1 overflow-y-auto bg-white">
        <div className="m-4">
          <Pages />
        </div>
      </main>
    </div>
  );
};

export default AppPrepare;
